import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {appendFormData} from "@/helpers/form";

export const galleryApi = createApi({
    reducerPath: 'galleryApi',
    tagTypes: ['gallery'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getGalleryImages: build.query({
            query: (data) => ({
                url: api.gallery.getGalleryImages(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, ...(queryArgs?.location_ids ?? [])]
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.uid === newItem.id)))
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
            transformResponse: (response, meta, {queryOptions}) => {
                return response.map((item) => ({
                    uid: item.id,
                    name: item.name,
                    status: 'done',
                    url: item.path,
                }))
            },
            providesTags: ['gallery']
        }),
        createGalleryImage: build.mutation({
            query: (data) => {
                const formData = new FormData();
                appendFormData(formData, data);

                return {
                    url: api.gallery.createGalleryImage(),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    },
                    body: formData,
                    formData: true
                };
            },
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    const {data} = await queryFulfilled
                    dispatch(
                        galleryApi.util.updateQueryData('getGalleryImages', {location_ids: [patch.location_id]}, (draft) => {
                            let newImages = [];
                            data.forEach(item => {
                                    newImages.push({
                                        name: item.name,
                                        status: 'done',
                                        url: item.path,
                                        uid: item.id,
                                    });
                            });

                            if (newImages.length > 0) {
                                draft.unshift(...newImages.reverse());
                            }
                        })
                    );
                } catch (e) {
                    console.error('Gallery failed:', e)
                }
            },
        }),
        deleteGalleryImage: build.mutation({
            query: ({id, ...data}) => ({
                url: api.gallery.deleteGalleryImage(id),
                method: 'DELETE',
                body: data
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled
                    dispatch(
                        galleryApi.util.updateQueryData('getGalleryImages', patch, (draft) => {
                            const index = draft?.findIndex((image) => image.uid === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            }
                        })
                    );
                } catch (e) {
                    console.error('Gallery failed:', e)
                }
            },
        }),
    })
})

export const {useLazyGetGalleryImagesQuery, useDeleteGalleryImageMutation} = galleryApi;

